import ScrollingModal from "./ScrollingModal";

export default ScrollingModal;
